import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromShop from '../reducers/shop.reducer';

export const getShopState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.shop);

export const getShopDataLoaded = createSelector(getShopState, fromShop.getShopDataLoaded);
export const getShopDataLoading = createSelector(getShopState, fromShop.getShopDataLoading);
export const getShipsToCountries = createSelector(getShopState, fromShop.getShipsToCountries);
